import type { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { MeasurementProvider, useOptionalMeasurements } from './MeasurementContext'
import { settingsService } from '../services/settings.service'

/** Catalogues use the company default; project/version scopes remain explicit. */
export function CompanyMeasurementProvider({ children }: { children: ReactNode }) {
  const { data, isLoading, error, refetch } = useQuery({ queryKey: ['settings'], queryFn: settingsService.getSettings })
  if (isLoading) return <p role="status">Chargement des unités…</p>
  if (error || !data) return <div role="alert">Impossible de charger les unités. <button onClick={() => refetch()}>Réessayer</button></div>
  return <MeasurementProvider system={data.tenantConfig.measurement_system ?? data.defaults.measurement_system}>{children}</MeasurementProvider>
}

/** Standalone forms use the catalogue default; embedded forms inherit their dossier. */
export function CatalogMeasurementBoundary({ children }: { children: ReactNode }) {
  const inherited = useOptionalMeasurements()
  return inherited ? <>{children}</> : <CompanyMeasurementProvider>{children}</CompanyMeasurementProvider>
}
